import axios from "@/libs/api.request";

export const getOrderList = (filterCond) => {
  return axios.request({
    url: "orders/getOrderList",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};

export const storeOrderDeliveryConfirm = (data) => {
  return axios.request({
    url: "orders/storeOrderDeliveryConfirm",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const getOrderCommentsList = (filterCond) => {
  return axios.request({
    url: "orders/getOrderCommentsList",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};

export const submitCommentsIssue = (data) => {
  return axios.request({
    url: "orders/submitCommentsIssue",
    data: data,
    csrf: true,
    method: "post",
  });
};
export const getOrderSalerServiceList = (filterCond) => {
  return axios.request({
    url: "orders/getOrderSalerServiceList",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};

export const approveOrderSalerService = (data) => {
  return axios.request({
    url: "orders/approveOrderSalerService",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const saveProOrderSalerService = (data) => {
  return axios.request({
    url: "orders/saveProOrderSalerService",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const refundSalerOrderService = (id) => {
  return axios.request({
    url: "orders/refundSalerOrderService",
    data: { id },
    csrf: true,
    method: "post",
  });
};

/**
 * 获取预约的用户信息
 * 2020-1-30
 */

export const getAppointmentList = (filterCond) => {
  return axios.request({
    url: "orders/getAppointmentList",
    data: filterCond,
    csrf: false,
    method: "post",
  });
};

export const confirmAppointment = (data) => {
  return axios.request({
    url: "orders/confirmAppointment",
    data: data,
    csrf: true,
    method: "post",
  });
};

/**
 * 保存体检报告
 */

export const storeAppointmentReportFile = (data) => {
  return axios.request({
    url: "orders/storeAppointmentReportFile",
    data: data,
    csrf: true,
    method: "post",
  });
};

export const cancelGoods = (id) => {
  return axios.request({
    url: "orders/cancelGoods",
    data: { id },
    csrf: true,
    method: "post",
  });
};
